module.exports = __webpack_public_path__ + "img/waistband width.fb7fdfb3.png";